export type APPLICATION_THEME_SETTINGS_TYPE = {
    defaultColor: string,
    primaryColor: string,
    primarySpecialColor: string,
    secondaryColor: string,
    secondarySpecialColor: string
};


export const APPLICATION_THEME_SETTINGS:APPLICATION_THEME_SETTINGS_TYPE = {
    defaultColor: "#222222",
    primaryColor: "#222222",
    primarySpecialColor: "#000080",
    secondaryColor: "#000",
    secondarySpecialColor: "#55AF3C",
};


export default APPLICATION_THEME_SETTINGS;
